<div class="w-full md:w-2/3 mx-auto px-4">
  <div class="">
    <form
      [formGroup]="companyForm"
      (ngSubmit)="onSubmit()"
      class="company-form"
      >
      <div class="text-center mb-8">
        <h1 class="text-2xl font-bold mb-4">
          Für Sie wurde ein Firmenkonto angelegt.
        </h1>
        <p class="text-gray-600">
          Um als Firma Angebote einreichen zu können, benötigen wir noch ein
          paar zusätzliche Informationen.
        </p>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex flex-col md:flex-row gap-4">
          <mat-form-field class="w-full">
            <mat-label i18n>Firmenname</mat-label>
            <input matInput formControlName="companyName" />
            @if (companyNameControl?.errors?.['required']) {
              <mat-error i18n>
              Firmenname ist erforderlich
            </mat-error>
            }
            @if (companyNameControl?.errors?.['minlength']) {
              <mat-error i18n>
              Firmenname muss mindestens 2 Zeichen lang sein
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label i18n>Ansprechperson</mat-label>
            <input matInput formControlName="contactPersonName" />
            @if (contactPersonNameControl?.errors?.['required']) {
              <mat-error
                i18n
                >
              Ansprechperson ist erforderlich
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="flex flex-col md:flex-row gap-4">
          <mat-form-field class="w-full">
            <mat-label i18n>Website</mat-label>
            <input matInput formControlName="website" />
            @if (websiteControl?.errors?.['required']) {
              <mat-error i18n>
              Website ist erforderlich
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label i18n>Telefonnummer</mat-label>
            <input matInput formControlName="phone" />
            @if (phoneControl?.errors?.['required']) {
              <mat-error i18n>
              Telefonnummer ist erforderlich
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="flex flex-row gap-4">
          <mat-form-field class="w-full">
            <mat-label i18n>E-Mail</mat-label>
            <input matInput type="email" formControlName="email" />
            @if (emailControl?.errors?.['required']) {
              <mat-error i18n>
              E-Mail ist erforderlich
            </mat-error>
            }
            @if (emailControl?.errors?.['email']) {
              <mat-error i18n>
              Bitte geben Sie eine gültige E-Mail-Adresse ein
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label i18n>UID</mat-label>
            <input matInput formControlName="uid" />
          </mat-form-field>
        </div>
      </div>

      <div formGroupName="address" class="flex flex-col gap-4 mt-8">
        <h3 i18n>Firmenanschrift</h3>

        <mat-form-field>
          <mat-label i18n>Straße und Hausnummer</mat-label>
          <input matInput formControlName="street" />
          @if (addressControl.get('street')?.errors?.['required']) {
            <mat-error
              i18n
              >
            Straße ist erforderlich
          </mat-error>
          }
        </mat-form-field>

        <div class="flex flex-col md:flex-row gap-4">
          <mat-form-field class="w-full">
            <mat-label i18n>Ort</mat-label>
            <input matInput formControlName="city" />
            @if (addressControl.get('city')?.errors?.['required']) {
              <mat-error
                i18n
                >
              Ort ist erforderlich
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label i18n>Postleitzahl</mat-label>
            <input matInput formControlName="postalCode" />
            @if (addressControl.get('postalCode')?.errors?.['required']) {
              <mat-error
                i18n
                >
              Postleitzahl ist erforderlich
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <p class="mt-8">
        Bitte geben Sie uns eine Liste von Kategorien, die Ihr Unternehmen
        anbietet.
      </p>
      <mat-form-field class="w-2/3">
        <mat-label i18n>Kategorien</mat-label>
        <mat-select formControlName="categories" multiple>
          @for (category of availableCategories | async; track category) {
            <mat-option
              [value]="category.id"
              >
              {{ category.name }}
            </mat-option>
          }
        </mat-select>
        @if (categoriesControl?.errors?.['required']) {
          <mat-error i18n>
          Bitte wählen Sie mindestens eine Kategorie aus
        </mat-error>
        }
      </mat-form-field>

      <div class="selected-categories flex flex-wrap gap-2 mt-2 w-2/3">
        @if (categoriesControl?.value?.length) {
          <mat-chip-set>
            @for (categoryId of categoriesControl?.value; track categoryId) {
              <mat-chip>
                {{ getCategoryName(categoryId) }}
              </mat-chip>
            }
          </mat-chip-set>
        }
      </div>

      <div class="flex flex-col mt-8">
        <mat-checkbox formControlName="privacyConsent">
          <span i18n
            >Ich stimme der
            <a
              href="https://www.sondis.at/datenschutzerklaerung/"
              target="_blank"
              rel="noopener noreferrer"
              >Datenschutzerklärung
              <mat-icon class="text-sm">open_in_new</mat-icon></a
            >
            zu</span
              >
            </mat-checkbox>
            @if (privacyConsentControl?.errors?.['required'] && privacyConsentControl?.dirty) {
              <mat-error
                i18n
                >
          Sie müssen der Datenschutzerklärung zustimmen
        </mat-error>
            }

            <mat-checkbox formControlName="termsConsent" class="!mt-0">
              <span i18n
                >Ich akzeptiere die
            <a
              href="https://www.sondis.at/agb/"
              target="_blank"
              rel="noopener noreferrer"
              >AGB <mat-icon class="text-sm">open_in_new</mat-icon></a
            ></span
                  >
                </mat-checkbox>
                @if (termsConsentControl?.errors?.['required'] && termsConsentControl?.dirty) {
                  <mat-error
                    i18n
                    >
          Sie müssen den AGB zustimmen
        </mat-error>
                }
              </div>

              <button
                class="button-blue mb-16 mt-8 text-lg ml-auto"
                [disabled]="!companyForm.valid || loading"
                type="submit"
                i18n
                >
        Firmenkonto fertigstellen
      </button>
            </form>
          </div>
        </div>
